import { Component, OnInit, Input, Output } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
import { QuickLinkResult } from '../models/search.model';
import { SelectItem } from 'primeng/api';
import { SearchService } from '../services/search.service';
import { environment } from '../../environments/environment';
import { ReportMetadata } from '../models/report.model';
import { ReportdashboardService } from '../services/reportdashboard.service';

@Component({
  selector: 'app-quick-links',
  templateUrl: './quick-links.component.html',
  styleUrls: ['./quick-links.component.css']
})
export class QuickLinksComponent implements OnInit {
  filelocationapi: string =environment.apiEndpoint+"/Report/DownloadReportByFileName?fileName=";
  first:number =0;
  @Output() dayCnt:number;
  title:string;
  fileNames: SelectItem[];
  countries: SelectItem[];
  fasPosts: SelectItem[];
  publishedOn: SelectItem[];
  titleNames:SelectItem[];

  results: QuickLinkResult[];
  reportScheduleData: ReportMetadata[];

  constructor(private route:ActivatedRoute,
             private searchService: SearchService,
             private reportDashboardService:ReportdashboardService) {
    this.titleNames = [
      { label: "Today's Reports", value: 1 },
      { label: "Past 3 Days Reports", value:3  },
      { label: "Past 5 Days Reports", value: 5 },
      { label: "Past 7 Days Reports", value: 7 },
      { label: "Past Month's Reports", value: 30 }
    ];



   }

  ngOnInit() {

    this.route.paramMap.subscribe(params => {
      this.dayCnt = +params.get('dayCnt');
      this.title =this.titleNames.filter(x=>x.value == this.dayCnt)[0].label;
      this.LoadData(this.dayCnt);
      this.first =0;
    });
  }

  paginate(event) {
    this.first = event.first;
}

   private LoadData(dayCnt:number)
   {
    var currentDate = new Date();
    currentDate.setHours(23,59,59,999);
    var fromDate = new Date().setDate(currentDate.getDate() - dayCnt);
    this.searchService.getQuickLinkResults$(new Date(fromDate).toDateString(),currentDate.toLocaleString()).subscribe(resp => {
      // console.log(resp);
       if (resp.ok) {
         this.results = resp.body;
         this.results.sort((a, b) => {
           if (a.publishedOn > b.publishedOn) return -1;
           if (a.publishedOn < b.publishedOn) return 1;
           return 0;
         });


         var fileNameType = new Array<string>();
         var postType = new Array<string>();
         var countryType = new Array<string>();
         var publishedOnDateType = new Array<string>();

         for (let i = 0; i < this.results.length; i++) {
           fileNameType.push(this.results[i].fileName);
           postType.push(this.results[i].postName);
           countryType.push(this.results[i].countryName);
           publishedOnDateType.push(this.results[i].publishedOn.toString());
         }

         this.fileNames = this.GetUniqueValues(fileNameType);
         this.fasPosts = this.GetUniqueValues(postType);
         this.countries = this.GetUniqueValues(countryType);
         this.publishedOn = this.dateSort(publishedOnDateType);


        // console.log(this.searchResults);
       }
     });
   }

   dateSort(filterItem: any[]): SelectItem[]{
    var returnArray = new Array<SelectItem>();
      for (let i = 0; i < filterItem.length; i++) {
        if (returnArray.filter(r => r.label == filterItem[i]).length == 0)
          returnArray.push({ label: filterItem[i], value: filterItem[i] });
      }
      returnArray.sort((a, b) => new Date(b.value).getTime() - new Date(a.value).getTime());
      return returnArray;
  }

     //TODO: Move this to a generic utils class
  GetUniqueValues(vals: any[]): SelectItem[] {
    var returnArry = new Array<SelectItem>();
    for (let cnt = 0; cnt < vals.length; cnt++) {
      if (returnArry.filter(r => r.label == vals[cnt]).length == 0)
        returnArry.push({ label: vals[cnt], value: vals[cnt] });
    }
    //console.log(returnArry.length);



    returnArry.sort(
      (a, b): number => {
        if (a.value < b.value) return -1;
        if (a.value > b.value) return 1;
        return 0;
      }
    );
    return returnArry;
  }

}
